import type { InjectionKey } from 'vue';

import type { ThemeContext } from '@shared/composables/useTheme';
import type { AuthContext } from '@shared/context/authContext';

export const authInjectionKey: InjectionKey<AuthContext> = Symbol('auth');
export const themeInjectionKey: InjectionKey<ThemeContext> = Symbol('theme');
